export const SYRIAN_CITIES = [
  "دمشق", "ريف دمشق", "حلب", "حمص", "حماة", "اللاذقية", "طرطوس",
  "إدلب", "دير الزور", "الرقة", "الحسكة", "درعا", "السويداء", "القنيطرة",
];

export const MATERIAL_TYPES = [
  "سيراميك", "بلاط", "حجر", "أدوات صحية", "خردوات", "رخام", "بورسلان", "فسيفساء",
];

// Product taxonomy used in Upload + Search
export const PRODUCT_TYPES = [
  "سيراميك", "أرضيات", "جدران", "مطابخ", "حمامات", "مسابح", "رخام", "جرانيت",
];

export const PRODUCT_CATEGORIES = [
  "سيراميك",
  "سيراميك أرضيات",
  "سيراميك جدران",
  "رخام",
  "سيراميك مسابح",
  "سيراميك مطابخ",
  "سيراميك حمامات",
];

// Phase 5A — NEW uploads only. Legacy PRODUCT_TYPES / PRODUCT_CATEGORIES above stay untouched (filters, edit modal, historical values).
// "أخرى" is supplied by SelectWithOther (custom text) and must not be listed here.
export const PRODUCT_SECTORS = ["مواد بناء", "أحذية", "أثاث", "ملابس"];
export const CATEGORIES_BY_SECTOR = {
  "مواد بناء": ["سيراميك جدران", "سيراميك أرضيات", "رخام", "بورسلان", "بلاط"],
  "أحذية": ["أحذية رجالية", "أحذية نسائية", "أحذية أطفال", "أحذية رياضية", "شحاطات", "بوط"],
  "أثاث": ["غرف نوم", "غرف جلوس", "طاولات", "كراسي", "خزائن", "مكاتب"],
  "ملابس": ["ملابس رجالية", "ملابس نسائية", "ملابس أطفال", "ملابس رياضية", "ملابس داخلية"],
};

// Phase 5B — measurement units for NEW uploads only; products without `unit` keep the historical meter behaviour.
export const UNITS = [
  { value: "meter", label: "متر", qtyLabel: "الكمية بالمتر", priceLabel: "السعر بالدولار للمتر", sizeLabel: "المقاس", sizePlaceholder: "40x40" },
  { value: "kg", label: "كيلوغرام", qtyLabel: "الكمية بالكيلوغرام", priceLabel: "السعر بالدولار للكيلوغرام", sizeLabel: "المقاس / العبوة", sizePlaceholder: "مثال: كيس 25 كغ" },
  { value: "liter", label: "لتر", qtyLabel: "الكمية باللتر", priceLabel: "السعر بالدولار للتر", sizeLabel: "المقاس / العبوة", sizePlaceholder: "مثال: غالون 4 لتر" },
  { value: "piece", label: "عدد", qtyLabel: "الكمية بالعدد", priceLabel: "السعر بالدولار للقطعة", sizeLabel: "المقاس", sizePlaceholder: "مثال: L أو 120x60" },
  { value: "shoe_size", label: "نمرة", qtyLabel: "الكمية بالعدد", priceLabel: "السعر بالدولار للقطعة", sizeLabel: "النمرة", sizePlaceholder: "مثال: 42" },
];
export const unitOf = (value) => UNITS.find((u) => u.value === value) || UNITS[0];
// Phase 5C-1 display helper: product without `unit` → historical meter labels, never inferred from category/type.
export const unitDisplay = (unit) => ({
  meter: { short: "م", per: "للمتر", qty: "الكمية (م)", price: "سعر المتر ($)" },
  kg: { short: "كغ", per: "للكيلوغرام", qty: "الكمية (كغ)", price: "سعر الكيلوغرام ($)" },
  liter: { short: "لتر", per: "للتر", qty: "الكمية (لتر)", price: "سعر اللتر ($)" },
  piece: { short: "قطعة", per: "للقطعة", qty: "الكمية (عدد)", price: "سعر القطعة ($)" },
  shoe_size: { short: "قطعة", per: "للقطعة", qty: "الكمية (عدد)", price: "سعر القطعة ($)" },
}[unit] || { short: "م", per: "للمتر", qty: "الكمية (م)", price: "سعر المتر ($)" });

// Count-based units: whole numbers only (legacy/no unit → meter → fractions allowed, unchanged)
export const isCountUnit = (unit) => unit === "piece" || unit === "shoe_size";
export const INT_QTY_MSG = "الكمية يجب أن تكون عدداً صحيحاً";
export const qtyInputProps = (unit) => (isCountUnit(unit) ? { step: "1", min: "1" } : null);
export const badCountQty = (unit, q) => isCountUnit(unit) && Number(q) !== Math.floor(Number(q));

export const PRODUCT_COLORS = [
  "أبيض", "أزرق", "فضي", "ذهبي", "أسود", "رمادي", "بني",
  "أحمر", "أصفر", "أخضر", "برتقالي", "بنفسجي", "وردي",
  "كحلي", "خمري", "رصاصي", "سماوي", "بيج",
  "مختلط الألوان (أكثر من لون)",
];

// Comprehensive world countries list in Arabic
export const COUNTRIES = [
  "أفغانستان", "ألبانيا", "الجزائر", "أندورا", "أنغولا", "الأرجنتين", "أرمينيا", "أستراليا", "النمسا", "أذربيجان",
  "البهاما", "البحرين", "بنغلاديش", "بربادوس", "روسيا البيضاء", "بلجيكا", "بليز", "بنين", "بوتان", "بوليفيا",
  "البوسنة والهرسك", "بوتسوانا", "البرازيل", "بروناي", "بلغاريا", "بوركينا فاسو", "بوروندي", "كمبوديا", "الكاميرون", "كندا",
  "الرأس الأخضر", "جمهورية أفريقيا الوسطى", "تشاد", "تشيلي", "الصين", "كولومبيا", "جزر القمر", "الكونغو", "كوستاريكا", "كرواتيا",
  "كوبا", "قبرص", "التشيك", "الدنمارك", "جيبوتي", "دومينيكا", "جمهورية الدومينيكان", "الإكوادور", "مصر", "السلفادور",
  "غينيا الاستوائية", "إريتريا", "إستونيا", "إسواتيني", "إثيوبيا", "فيجي", "فنلندا", "فرنسا", "الغابون", "غامبيا",
  "جورجيا", "ألمانيا", "غانا", "اليونان", "غرينادا", "غواتيمالا", "غينيا", "غينيا بيساو", "غيانا", "هايتي",
  "هندوراس", "هنغاريا", "آيسلندا", "الهند", "إندونيسيا", "إيران", "العراق", "أيرلندا", "إسرائيل", "إيطاليا",
  "ساحل العاج", "جامايكا", "اليابان", "الأردن", "كازاخستان", "كينيا", "كيريباتي", "الكويت", "قيرغيزستان", "لاوس",
  "لاتفيا", "لبنان", "ليسوتو", "ليبيريا", "ليبيا", "ليختنشتاين", "ليتوانيا", "لوكسمبورغ", "مدغشقر", "مالاوي",
  "ماليزيا", "المالديف", "مالي", "مالطا", "جزر مارشال", "موريتانيا", "موريشيوس", "المكسيك", "ميكرونيزيا", "مولدوفا",
  "موناكو", "منغوليا", "الجبل الأسود", "المغرب", "موزمبيق", "ميانمار", "ناميبيا", "ناورو", "نيبال", "هولندا",
  "نيوزيلندا", "نيكاراغوا", "النيجر", "نيجيريا", "كوريا الشمالية", "مقدونيا الشمالية", "النرويج", "عُمان", "باكستان", "بالاو",
  "فلسطين", "بنما", "بابوا غينيا الجديدة", "باراغواي", "بيرو", "الفلبين", "بولندا", "البرتغال", "قطر", "رومانيا",
  "روسيا", "رواندا", "سانت كيتس ونيفيس", "سانت لوسيا", "سانت فنسنت والغرينادين", "ساموا", "سان مارينو", "ساو تومي وبرينسيبي", "المملكة العربية السعودية", "السنغال",
  "صربيا", "سيشل", "سيراليون", "سنغافورة", "سلوفاكيا", "سلوفينيا", "جزر سليمان", "الصومال", "جنوب أفريقيا", "كوريا الجنوبية",
  "جنوب السودان", "إسبانيا", "سريلانكا", "السودان", "سورينام", "السويد", "سويسرا", "سوريا", "تايوان", "طاجيكستان",
  "تنزانيا", "تايلاند", "تيمور الشرقية", "توغو", "تونغا", "ترينيداد وتوباغو", "تونس", "تركيا", "تركمانستان", "توفالو",
  "أوغندا", "أوكرانيا", "الإمارات العربية المتحدة", "المملكة المتحدة", "الولايات المتحدة", "أوروغواي", "أوزبكستان", "فانواتو", "الفاتيكان", "فنزويلا",
  "فيتنام", "اليمن", "زامبيا", "زيمبابوي",
];

